module.exports = __webpack_public_path__ + "img/IMG_0373.abc89aa4.jpg";